import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  DesignInfoInputDialogContext,
  DesignInfoInputDialogInitialState,
} from ".";

export const DesignInfoInputDialogStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(DesignInfoInputDialogInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <DesignInfoInputDialogContext.Provider value={context}>
      {children}
    </DesignInfoInputDialogContext.Provider>
  );
};
